export default {
  SEARCH: '搜索',
  ANY_CATEGORY: '任何类别',
  SINGLE_CHOICE: '(单选)',
  ASIN_LIST: '商品列表',
  SEARCH_NOT_FOUND: '搜索结果为空，试试别的关键词',
  NO_MATCH_ASIN: '暂无匹配商品，试试其他选项吧',
  REQUEST_FAILED_RELOAD: '请求失败，点击重新加载',
  NO_MORE: '没有更多了'
};
